// Shared MSAL instance + access-token helper used by the API client.

import { PublicClientApplication } from '@azure/msal-browser'
import { buildMsalConfig, apiRequest } from './authConfig.js'

// Created once by main.jsx, after the sign-in identifiers load from the server
// (authConfig.js). Null until then; nothing calls getAccessToken() before the
// app renders, and the app renders only after this is set.
export let msalInstance = null

export function createMsalInstance(authConfig) {
  msalInstance = new PublicClientApplication(buildMsalConfig(authConfig))
  return msalInstance
}

// Returns a valid access token for the API, refreshing silently when possible.
// Interactive fallback order matters for an all-day tool: a POPUP first, so an
// expired session mid-Approve re-authenticates WITHOUT a full-page navigation
// (the old redirect threw away the CSR's edited draft, reason codes, and any
// in-flight work). Redirect only as the last resort (popup blocked/closed).
export async function getAccessToken() {
  if (!msalInstance) return null
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0]
  if (!account) return null
  try {
    const res = await msalInstance.acquireTokenSilent({ ...apiRequest, account })
    return res.accessToken
  } catch {
    try {
      const res = await msalInstance.acquireTokenPopup({ ...apiRequest, account })
      return res.accessToken
    } catch {
      await msalInstance.acquireTokenRedirect({ ...apiRequest, account })
      return null
    }
  }
}
